<script>
   /**************************************************************/
   /* Outliers widget.                                           */
   /**************************************************************/

   import { Container, ButtonCancel, ButtonUndo } from 'svelte-controls-basic';


   let {
      outliers,
      dataset,
      resetOutliers,
      undoOutliers,
   } = $props();
</script>

{#if dataset && outliers && outliers.length > 0 }
   <!-- dataset is loaded - show info and cancel button -->
   <Container>
      <p class="outliers">
         <span style="color:#a0a0a0;">Removed:</span>
         {#each outliers as v}
         <span class="item">{dataset.objlabels[v]}</span>
         {/each}
      </p>
      {#if outliers.length > 1}
      <ButtonUndo onclick={undoOutliers} />
      {/if}
      <ButtonCancel onclick={resetOutliers} />
   </Container>
{/if}


<style>
   .outliers{
      line-height: 1.5em;
      text-align: left;
      padding: 0.5em 0;
      flex: 0 0 80%;
   }

   .outliers > .item {
      color: #DC143C;
      background: #DC143C20;

      display: inline-block;
      white-space: nowrap;
      vertical-align: middle;
      max-width: 10ch;
      overflow: hidden;
      text-overflow: ellipsis;

      padding: 0.1em 0.5em;
      margin: 0.2em 0.1em;
      border-radius: 0.2em;
   }
</style>